import {
  BareEventTemplate,
  EventTemplate,
  NewEventTemplate,
  PaginateEventTemplateParams,
} from '../../../shared/types/eventTemplate';
import { apiGet, apiPost, apiPut, RequestMethod, apiRequest } from '.';
import { populateEventTemplate } from '@go-shared/lib/eventTemplate';
import { Event } from '@go-shared/types/event';
import { PaginationResult } from '@go-shared/types/pagination';
import qs from 'query-string';

export async function getBrandEventTemplates(brandId: string): Promise<BareEventTemplate[]> {
  let eventTemplates = (await apiGet(`/brand/${brandId}/event-template`)) as any;
  return eventTemplates;
}

export async function getPropertyEventTemplates(propertyId: string): Promise<BareEventTemplate[]> {
  let eventTemplates = (await apiGet(`/property/${propertyId}/event-template`)) as any;
  return eventTemplates;
}

/**
 * Rebound function so we don't need to refactor all the imports
 * Since now the server uses the populate function, we moved it to shared library
 *
 */

export const populate = populateEventTemplate;

/**
 * Creates a new event template in GO
 *
 */
export async function create(newTemplate: NewEventTemplate): Promise<BareEventTemplate> {
  return apiPost(`/brand/${newTemplate.brand}/event-template`, newTemplate);
}

/**
 * Updates an event template in GO
 *
 */
export async function update(
  eventTemplate: BareEventTemplate,
  action?: 'promote' | 'demote'
): Promise<BareEventTemplate> {
  const payload = {
    ...eventTemplate,
    // workaround when setting segment to undefined (because is set as 'unassigned')
    // here it's set to null because when the payload is serialized
    // all the undefined values will be removed
    ...(eventTemplate.segment === undefined && { segment: null }),
  };

  return apiPut(`/brand/${eventTemplate.brand}/event-template/${eventTemplate._id}`, payload, {
    action,
  });
}

/**
 * Changes the `archived` attribute of an event template
 */
export async function setArchived(eventTemplate: BareEventTemplate): Promise<BareEventTemplate> {
  return apiPut(
    `/brand/${eventTemplate.brand}/event-template/${eventTemplate._id}/archived`,
    eventTemplate
  );
}

/**
 * Opposite of populate. Given an EventTemplate, prepare it to be sent to the API.
 *
 */
export function bare(eventTemplate: EventTemplate): BareEventTemplate {
  return {
    ...eventTemplate,
    brand: eventTemplate.brand._id,
    segment: eventTemplate.segment ? eventTemplate.segment._id : undefined,
    levels: eventTemplate.levels.map(l => l._id),
    attributes: eventTemplate.attributes.map(a => a._id),
  };
}

/**
 * Generates a CSV file with the Event templates data
 */
export const exportEventTemplatesToCSV = (propertyId: string) => {
  return apiGet<{ location: string }>(`/property/${propertyId}/event-template/export-csv`);
};

export async function paginateEventTemplates(
  params: PaginateEventTemplateParams
): Promise<PaginationResult<EventTemplate>> {
  return apiGet(`/event-template/paginate?${qs.stringify(params)}`);
}

export const uploadEventImage = async (
  eventTemplate: EventTemplate,
  file: File
): Promise<{ location: string; name: string }> => {
  const fd = new FormData();
  fd.append('eventImage', file);

  return apiRequest(
    RequestMethod.Post,
    `/brand/${eventTemplate.brand._id}/event-template/${eventTemplate._id}/image`,
    true,
    null,
    fd,
    {
      'Content-Type': 'multipart/form-data',
    }
  );
};

export const findEventsBySailingDays = async ({
  propertyId,
  lang,
  startDate,
  endDate,
}: {
  propertyId: string;
  lang: string | undefined;
  startDate: string;
  endDate: string;
}): Promise<[string, Event[]][]> => {
  return apiGet(`/property/${propertyId}/sailing-days-events`, { lang, startDate, endDate });
};
